import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { client } from "../client";
// import MasonaryLayout from './MasonryLayout';
import Spinner from "./Spinner";
import { searchQuery } from "../utils/data";
import { feedQuery } from "../utils/data";
import MasonaryLayout from "./MasonaryLayout";

const Feed = () => {
  const [loading, setLoading] = useState(true);
  const [pins, setPins] = useState(null);

  const { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) {
      const query = searchQuery(categoryId);
      client.fetch(query).then((data) => {
        setPins(data);
        setLoading(false);
      });

      setLoading(true);
    } else {
      client.fetch(feedQuery).then((data) => {
        setPins(data);
        setLoading(false);
      });
    }
  }, [categoryId]);

  if (loading)
    return <Spinner message="We are adding New ides to your Feed!" />;
  if(!pins?.length) return <h2>No Pins Available</h2>

  return <div>{pins && <MasonaryLayout pins={pins} />}</div>;
};

export default Feed;
